export const LANDING_SECTIONS = [
  { id: "about", label: "About" },
  { id: "insurance", label: "Insurance" },
  { id: "services", label: "Services" },
  { id: "features", label: "Features" },
  { id: "states", label: "States" },
  { id: "peer-support", label: "Live Peer Support" },
  { id: "universities", label: "Universities" },
  { id: "partners", label: "Partners" },
  { id: "team", label: "Team" },
  { id: "faq", label: "FAQs" },
] as const;

export const CONTACT_INFO = {
  zoom: "https://zoom.us/s/7575288881",
  phone: "(757) 528-8881",
  phoneRaw: "7575288881",
  email: "info@adhd-aid.com",
} as const;

export const SOCIAL_LINKS = [
  {
    href: "https://www.linkedin.com/company/adhd-aid",
    label: "LinkedIn",
    iconName: "LinkedinIcon" as const,
  },
  {
    href: "https://www.facebook.com/profile.php?id=61572674022562",
    label: "Facebook",
    iconName: "FacebookIcon" as const,
  },
  {
    href: "https://www.instagram.com/adhdaid.psychiatry/",
    label: "Instagram",
    iconName: "InstagramIcon" as const,
  },
  {
    href: "https://ph.pinterest.com/adhdaid1/",
    label: "Pinterest",
    iconName: "PinterestIcon" as const,
  },
] as const;
